import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

export function ClearFilterIcon({ onClear }) {
  const handleClick = (event) => {
    event.stopPropagation();
    onClear();
  };

  return (
    <FontAwesomeIcon
      className="clickable"
      icon={faTimes}
      name="remove-control"
      size="sm"
      onClick={handleClick}
      onMouseDown={event => event.stopPropagation()}
    />
  );
}

ClearFilterIcon.propTypes = {
  onClear: PropTypes.func.isRequired
};

export default ClearFilterIcon;
